module.exports = __webpack_public_path__ + "img/bodegas-ecommerce.026811a9.svg";